import { getPersistentJson } from '../../../vrs-auth/storage';
const AVATAR_COLORS = [
    '#4A90D9', '#7B68EE', '#E74C3C', '#2ECC71', '#F39C12',
    '#9B59B6', '#1ABC9C', '#E67E22', '#3498DB', '#E91E63'
];
export function getInitials(name) {
    return (name || '').trim().split(/\s+/).map(w => w[0]).slice(0, 2).join('').toUpperCase();
}
export function pickAvatarColor(name, explicit) {
    if (explicit)
        return explicit;
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}
export function formatDate(dateStr) {
    if (!dateStr)
        return 'Never';
    const d = new Date(dateStr);
    return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}
export function getCurrentClientId() {
    const user = getPersistentJson('vrs_user_info');
    return user?.id || user?.userId || null;
}
export function parseCSV(text) {
    const lines = text.split(/\r?\n/).filter(l => l.trim());
    if (lines.length < 2)
        return [];
    const headers = lines[0].split(',').map(h => h.trim().toLowerCase());
    const nameIdx = headers.findIndex(h => h.includes('name'));
    const phoneIdx = headers.findIndex(h => h.includes('phone') || h.includes('tel') || h.includes('mobile'));
    const emailIdx = headers.findIndex(h => h.includes('email') || h.includes('mail'));
    const orgIdx = headers.findIndex(h => h.includes('org') || h.includes('company'));
    if (nameIdx === -1)
        return [];
    return lines.slice(1).map(line => {
        const cols = line.split(',').map(c => c.trim().replace(/^"|"$/g, ''));
        return {
            name: cols[nameIdx] || '',
            phone_number: phoneIdx >= 0 ? cols[phoneIdx] || '' : '',
            email: emailIdx >= 0 ? cols[emailIdx] || '' : '',
            organization: orgIdx >= 0 ? cols[orgIdx] || '' : ''
        };
    }).filter(r => r.name);
}
export function parseVCard(text) {
    const contacts = [];
    const blocks = text.split('BEGIN:VCARD');
    for (const block of blocks) {
        if (!block.includes('END:VCARD'))
            continue;
        const entry = {};
        for (const line of block.split(/\r?\n/)) {
            const lower = line.toLowerCase();
            if (lower.startsWith('fn:') || lower.startsWith('fn;')) {
                entry.name = line.replace(/^fn[^:]*:/i, '').trim();
            }
            else if (lower.startsWith('tel:') || lower.startsWith('tel;')) {
                entry.phone_number = line.replace(/^tel[^:]*:/i, '').trim();
            }
            else if (lower.startsWith('email:') || lower.startsWith('email;')) {
                entry.email = line.replace(/^email[^:]*:/i, '').trim();
            }
            else if (lower.startsWith('org:')) {
                entry.organization = line.replace(/^org:/i, '').trim();
            }
        }
        if (entry.name) {
            contacts.push(entry);
        }
    }
    return contacts;
}
